import React, { useEffect } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import BlockLoading from '../../common/BlockLoading';
import RowsFactory from './RowsFactory';
import KeysManager from './KeysManager';
import ArrowsManager from './ArrowsManager';
import ShortcutsWrapper from './ShortcutsWrapper';

import useApiOrLocalV2 from '../../../../hooks/useApiOrLocalV2';
import useListScroll from './hooks/useListScroll';

const ConnectedFixedSizeList = ({
  id, pathApi, data, width, height, rowSize, rowType, sortable, enableKeys, enableArrows, enableShortcuts,
  from, style, styleLoading, showLoading = true, isBoost = false, className = '', isLoadMore = false, dnd = true,
  api, isBaseRootApi = true, customFormatData = null, callbackEmpty = null, checkVisibility = null,
  name = null, loadMoreWithApi = true, cache = true, autoFirstLoadCondition = null
}) => {

  let { ref, onScroll } = useListScroll();
  const {
    storeList, onClickItem, unSelectedItems, end,
    onDropSortable, onDeleteItem, onMassDelete, onLoadMore, allSelectedItems
  } = useApiOrLocalV2(api, pathApi, data, id, from, isBoost, (rowType === `Partial`), isBaseRootApi, customFormatData, loadMoreWithApi, cache);

  useEffect(() => {
    if (!storeList.items) return;
    if (callbackEmpty && storeList.items.length === 0) {
      callbackEmpty(id);
    }
    if (checkVisibility) {
      checkVisibility();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeList.items]);

  if (autoFirstLoadCondition !== null && storeList.items && storeList.items.length > 0) {
    storeList.items.map( (item, i) => {
      if (item.autoFirstLoadDeck === undefined) {
        item.autoFirstLoadDeck = autoFirstLoadCondition(item, i);
      }
      return item;  
    })
  }

  return (!storeList.items || (storeList.hasOwnProperty("next") && storeList.next !== null && isLoadMore && rowType === `Partial`) )
    ? (showLoading ? <BlockLoading height={height} style={styleLoading} /> : null)
    : (
      <div id={`FSL-${id}`} className={className} ref={ref} style={{ outline: `none`, width, height: `auto`, overflowY: `auto`, overflowX: `hidden`, ...style }}
        tabIndex={0} onScroll={onScroll} onBlur={unSelectedItems}
      >
        { storeList.items.map( (item, index) => <RowsFactory key={`RowType${index}`} type={rowType} options={{
            key: `RowType${index}`,
            idParent: id,
            nameParent: name,
            index,
            item,
            width,
            height: rowSize,
            onClick: onClickItem,
            dnd,
            end,
            onDropSortable,
            onLoadMore: (isLoadMore) ? onLoadMore : null,
            onDelete: onDeleteItem,
            isSortable: sortable,
            containerRef: ref
          }} />
        )}
        { (isLoadMore && storeList.next) ? <span className={`loading-more type-placeholder`}>Loading ...</span> : null }
        { (enableKeys) && <KeysManager id={id} nameParent={name} onMassDelete={onMassDelete} /> }
        { enableArrows && <ArrowsManager id={id} isReduce={(rowType === `Partial`)} onSelect={onClickItem} items={storeList.items} /> }
        { enableShortcuts && <ShortcutsWrapper onAll={allSelectedItems} onEscape={unSelectedItems} /> }
      </div>
    )
};

ConnectedFixedSizeList.propTypes = {
  id: PropTypes.any.isRequired,
  pathApi: PropTypes.string,
  data: PropTypes.array,
  isBaseRootApi: PropTypes.bool,
  width: PropTypes.any.isRequired,
  rowSize: PropTypes.number.isRequired,
  rowType: PropTypes.string.isRequired,
  sortable: PropTypes.bool.isRequired,
  enableKeys: PropTypes.bool,
  enableArrows: PropTypes.bool,
  from: PropTypes.string,
  style: PropTypes.object,
  styleLoading: PropTypes.object,
  showLoading: PropTypes.bool,
  isBoost: PropTypes.bool,
  dnd: PropTypes.bool,
  className: PropTypes.string
}

const FixedSizeList = connect(
  state => ({
    api: state.api
  })
)(ConnectedFixedSizeList);

export default FixedSizeList;
